// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.App-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 1.25rem 2rem;
  color: white;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0;
}

.header-main-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 2rem;
}

.header-left {
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-shrink: 0;
}

.header-left h1 {
  margin: 0 0 0.25rem 0;
  font-size: 1.75rem;
  font-weight: 600;
  letter-spacing: -0.02em;
  line-height: 1.2;
}

.header-left p {
  margin: 0;
  font-size: 0.9rem;
  opacity: 0.85;
  font-weight: 400;
  line-height: 1.2;
}

.header-nav-section {
  display: flex;
  align-items: center;
  flex: 1 1;
  justify-content: flex-end;
  gap: 0;
  padding-left: 2rem;
  border-left: 1px solid rgba(255, 255, 255, 0.2);
  margin-left: 2rem;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-top: 0.75rem;
  width: 100%;
  justify-content: flex-end;
  padding-top: 0.75rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.header-menu-button {
  padding: 6px 16px;
  background: transparent;
  color: rgba(255, 255, 255, 0.85);
  border: none;
  border-bottom: 2px solid transparent;
  border-radius: 0;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.2s ease;
  position: relative;
  white-space: nowrap;
}

.header-menu-button:hover {
  color: white;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 4px 4px 0 0;
}

.header-menu-button.active {
  color: white;
  background: transparent;
  border-bottom-color: white;
  font-weight: 600;
}

.user-info {
  font-size: 0.875rem;
  opacity: 0.85;
  font-weight: 400;
}

.user-info strong {
  color: #fff;
  font-weight: 500;
}

.logout-button {
  background: rgba(255, 255, 255, 0.12);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.25);
  padding: 6px 14px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.2s ease;
}

.logout-button:hover {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.4);
}

.main-nav {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  margin: 0;
  padding: 0;
}

.main-nav button,
.main-nav a {
  padding: 6px 16px;
  background: transparent;
  color: rgba(255, 255, 255, 0.85);
  border: none;
  border-bottom: 2px solid transparent;
  border-radius: 0;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.2s ease;
  position: relative;
  white-space: nowrap;
  text-decoration: none;
  display: inline-block;
}

.main-nav button:hover,
.main-nav a:hover {
  color: white;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 4px 4px 0 0;
}

.main-nav button.active,
.main-nav a.active {
  color: white;
  background: transparent;
  border-bottom-color: white;
  font-weight: 600;
}

.nav-dropdown {
  position: relative;
  display: inline-block;
}

.nav-dropdown-menu {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  min-width: 220px;
  background: linear-gradient(135deg, #5a6fd8 0%, #6a4c93 100%);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  border-radius: 0 0 6px 6px;
  overflow: hidden;
  z-index: 100;
  padding: 4px 0;
}

.nav-dropdown:hover .nav-dropdown-menu,
.nav-dropdown:focus-within .nav-dropdown-menu {
  display: block;
}

.nav-dropdown-menu a {
  display: block;
  padding: 8px 20px;
  background: transparent;
  color: rgba(255, 255, 255, 0.85);
  font-size: 0.875rem;
  font-weight: 500;
  text-decoration: none;
  white-space: nowrap;
  transition: all 0.2s ease;
}

.nav-dropdown-menu a:hover {
  color: white;
  background: rgba(255, 255, 255, 0.12);
}

.sub-nav {
  width: 100%;
  background: linear-gradient(135deg, #5a6fd8 0%, #6a4c93 100%);
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.sub-nav-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 0;
  width: 100%;
  max-width: 100%;
  padding: 0 2rem;
  box-sizing: border-box;
}

.sub-nav .submenu-item-right {
  margin-left: auto;
  margin-right: 2rem;
}

.sub-nav .submenu-item {
  padding: 8px 20px;
  background: transparent;
  border: none;
  border-bottom: 2px solid transparent;
  color: rgba(255, 255, 255, 0.85);
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  white-space: nowrap;
}

.sub-nav .submenu-item:hover {
  color: white;
  background: rgba(255, 255, 255, 0.1);
}

.sub-nav .submenu-item.active {
  color: white;
  background: transparent;
  border-bottom-color: white;
  font-weight: 600;
}

.App-main {
  flex: 1 1;
  padding: 1rem;
  width: 100%;
  margin: 0;
  box-sizing: border-box;
  transition: margin-left 0.3s ease;
}

/* Layout adjustments when sidebar is visible */
.App.with-sidebar {
  position: relative;
}

.App.with-sidebar .App-main {
  margin-left: 280px;
  width: calc(100% - 280px);
  max-width: calc(100vw - 280px);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

/* Content wrapper to center content when sidebar is visible */
.App.with-sidebar .App-main > * {
  max-width: 100%;
  box-sizing: border-box;
}

/* Ensure containers with max-width are centered and fit within available space */
.App.with-sidebar .App-main .home-container,
.App.with-sidebar .App-main .equity-container,
.App.with-sidebar .App-main .open-positions-container,
.App.with-sidebar .App-main .trades-container,
.App.with-sidebar .App-main .pmcc-container,
.App.with-sidebar .App-main .settings-page,
.App.with-sidebar .App-main .todo-container {
  max-width: min(100%, calc(100vw - 280px - 2rem));
  margin-left: auto;
  margin-right: auto;
  box-sizing: border-box;
}

/* Override specific max-widths when sidebar is visible to ensure they fit */
.App.with-sidebar .App-main .home-container {
  max-width: min(1400px, calc(100vw - 280px - 2rem));
}

.App.with-sidebar .App-main .pmcc-container {
  max-width: min(1200px, calc(100vw - 280px - 2rem));
}

/* Prevent horizontal overflow when sidebar is visible */
.App.with-sidebar {
  overflow-x: hidden;
}

.App.with-sidebar .App-main {
  overflow-x: hidden;
}

/* Ensure tables and wide content don't overflow */
.App.with-sidebar .App-main table,
.App.with-sidebar .App-main .table-container,
.App.with-sidebar .App-main .data-table {
  max-width: 100%;
  overflow-x: auto;
  box-sizing: border-box;
}

.App.with-sidebar .App-header {
  margin-left: 280px;
  width: calc(100% - 280px);
  max-width: calc(100vw - 280px);
  box-sizing: border-box;
}

.App.with-sidebar .sub-nav {
  margin-left: 280px;
  width: calc(100% - 280px);
  max-width: calc(100vw - 280px);
  box-sizing: border-box;
}

@media (max-width: 768px) {
  .App.with-sidebar .App-main {
    margin-left: 0;
    width: 100%;
    max-width: 100vw;
  }

  .App.with-sidebar .App-header {
    margin-left: 0;
    width: 100%;
    max-width: 100vw;
  }

  .App.with-sidebar .sub-nav {
    margin-left: 0;
    width: 100%;
    max-width: 100vw;
  }
}

.loading, .error {
  text-align: center;
  padding: 2rem;
  font-size: 1.2rem;
}

.error {
  color: #d32f2f;
  background-color: #ffebee;
  border-radius: 4px;
  border: 1px solid #ffcdd2;
}

.empty-state {
  text-align: center;
  padding: 4rem 2rem;
  color: #666;
  font-size: 1.1rem;
}

.data-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.data-card {
  background: white;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  transition: transform 0.2s, box-shadow 0.2s;
}

.data-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

.data-card h3 {
  color: #282c34;
  margin-bottom: 0.5rem;
  font-size: 1.3rem;
}

.data-card .description {
  color: #666;
  margin-bottom: 1rem;
  line-height: 1.5;
}

.data-card .source {
  color: #888;
  font-size: 0.9rem;
  margin-bottom: 0.5rem;
}

.data-card .date {
  color: #888;
  font-size: 0.85rem;
  margin-bottom: 1rem;
}

.data-preview {
  padding-top: 1rem;
  border-top: 1px solid #eee;
  color: #555;
}

.refresh-btn {
  display: block;
  margin: 2rem auto;
  padding: 0.75rem 2rem;
  background-color: #282c34;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.2s;
}

.refresh-btn:hover {
  background-color: #3d4148;
}

.refresh-btn:active {
  transform: scale(0.98);
}

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,YAAY;EACZ,sCAAsC;EACtC,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAO;EACP,yBAAyB;EACzB,MAAM;EACN,kBAAkB;EAClB,+CAA+C;EAC/C,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,gCAAgC;EAChC,YAAY;EACZ,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,2CAA2C;EAC3C,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,UAAU;AACZ;;AAEA;;EAEE,iBAAiB;EACjB,uBAAuB;EACvB,gCAAgC;EAChC,YAAY;EACZ,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;;EAEE,YAAY;EACZ,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;;EAEE,YAAY;EACZ,uBAAuB;EACvB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,gBAAgB;EAChB,6DAA6D;EAC7D,yCAAyC;EACzC,0BAA0B;EAC1B,gBAAgB;EAChB,YAAY;EACZ,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,uBAAuB;EACvB,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,6DAA6D;EAC7D,sCAAsC;EACtC,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,MAAM;EACN,WAAW;EACX,eAAe;EACf,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,oCAAoC;EACpC,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,WAAW;EACX,SAAS;EACT,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA,+CAA+C;AAC/C;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,8BAA8B;EAC9B,sBAAsB;EACtB,aAAa;EACb,sBAAsB;AACxB;;AAEA,8DAA8D;AAC9D;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA,iFAAiF;AACjF;;;;;;;EAOE,gDAAgD;EAChD,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,4EAA4E;AAC5E;EACE,kDAAkD;AACpD;;AAEA;EACE,kDAAkD;AACpD;;AAEA,wDAAwD;AACxD;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,kDAAkD;AAClD;;;EAGE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":[".App {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.App-header {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  padding: 1.25rem 2rem;\n  color: white;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.08);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.header-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0;\n}\n\n.header-main-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  gap: 2rem;\n}\n\n.header-left {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.header-left h1 {\n  margin: 0 0 0.25rem 0;\n  font-size: 1.75rem;\n  font-weight: 600;\n  letter-spacing: -0.02em;\n  line-height: 1.2;\n}\n\n.header-left p {\n  margin: 0;\n  font-size: 0.9rem;\n  opacity: 0.85;\n  font-weight: 400;\n  line-height: 1.2;\n}\n\n.header-nav-section {\n  display: flex;\n  align-items: center;\n  flex: 1;\n  justify-content: flex-end;\n  gap: 0;\n  padding-left: 2rem;\n  border-left: 1px solid rgba(255, 255, 255, 0.2);\n  margin-left: 2rem;\n}\n\n.header-right {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  margin-top: 0.75rem;\n  width: 100%;\n  justify-content: flex-end;\n  padding-top: 0.75rem;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.header-menu-button {\n  padding: 6px 16px;\n  background: transparent;\n  color: rgba(255, 255, 255, 0.85);\n  border: none;\n  border-bottom: 2px solid transparent;\n  border-radius: 0;\n  cursor: pointer;\n  font-size: 0.875rem;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  position: relative;\n  white-space: nowrap;\n}\n\n.header-menu-button:hover {\n  color: white;\n  background: rgba(255, 255, 255, 0.08);\n  border-radius: 4px 4px 0 0;\n}\n\n.header-menu-button.active {\n  color: white;\n  background: transparent;\n  border-bottom-color: white;\n  font-weight: 600;\n}\n\n.user-info {\n  font-size: 0.875rem;\n  opacity: 0.85;\n  font-weight: 400;\n}\n\n.user-info strong {\n  color: #fff;\n  font-weight: 500;\n}\n\n.logout-button {\n  background: rgba(255, 255, 255, 0.12);\n  color: white;\n  border: 1px solid rgba(255, 255, 255, 0.25);\n  padding: 6px 14px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.875rem;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.logout-button:hover {\n  background: rgba(255, 255, 255, 0.2);\n  border-color: rgba(255, 255, 255, 0.4);\n}\n\n.main-nav {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 8px;\n  margin: 0;\n  padding: 0;\n}\n\n.main-nav button,\n.main-nav a {\n  padding: 6px 16px;\n  background: transparent;\n  color: rgba(255, 255, 255, 0.85);\n  border: none;\n  border-bottom: 2px solid transparent;\n  border-radius: 0;\n  cursor: pointer;\n  font-size: 0.875rem;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  position: relative;\n  white-space: nowrap;\n  text-decoration: none;\n  display: inline-block;\n}\n\n.main-nav button:hover,\n.main-nav a:hover {\n  color: white;\n  background: rgba(255, 255, 255, 0.08);\n  border-radius: 4px 4px 0 0;\n}\n\n.main-nav button.active,\n.main-nav a.active {\n  color: white;\n  background: transparent;\n  border-bottom-color: white;\n  font-weight: 600;\n}\n\n.nav-dropdown {\n  position: relative;\n  display: inline-block;\n}\n\n.nav-dropdown-menu {\n  display: none;\n  position: absolute;\n  top: 100%;\n  left: 0;\n  min-width: 220px;\n  background: linear-gradient(135deg, #5a6fd8 0%, #6a4c93 100%);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n  border-radius: 0 0 6px 6px;\n  overflow: hidden;\n  z-index: 100;\n  padding: 4px 0;\n}\n\n.nav-dropdown:hover .nav-dropdown-menu,\n.nav-dropdown:focus-within .nav-dropdown-menu {\n  display: block;\n}\n\n.nav-dropdown-menu a {\n  display: block;\n  padding: 8px 20px;\n  background: transparent;\n  color: rgba(255, 255, 255, 0.85);\n  font-size: 0.875rem;\n  font-weight: 500;\n  text-decoration: none;\n  white-space: nowrap;\n  transition: all 0.2s ease;\n}\n\n.nav-dropdown-menu a:hover {\n  color: white;\n  background: rgba(255, 255, 255, 0.12);\n}\n\n.sub-nav {\n  width: 100%;\n  background: linear-gradient(135deg, #5a6fd8 0%, #6a4c93 100%);\n  box-shadow: 0 2px 8px rgba(0,0,0,0.08);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.sub-nav-container {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 0;\n  width: 100%;\n  max-width: 100%;\n  padding: 0 2rem;\n  box-sizing: border-box;\n}\n\n.sub-nav .submenu-item-right {\n  margin-left: auto;\n  margin-right: 2rem;\n}\n\n.sub-nav .submenu-item {\n  padding: 8px 20px;\n  background: transparent;\n  border: none;\n  border-bottom: 2px solid transparent;\n  color: rgba(255, 255, 255, 0.85);\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  position: relative;\n  white-space: nowrap;\n}\n\n.sub-nav .submenu-item:hover {\n  color: white;\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.sub-nav .submenu-item.active {\n  color: white;\n  background: transparent;\n  border-bottom-color: white;\n  font-weight: 600;\n}\n\n.App-main {\n  flex: 1;\n  padding: 1rem;\n  width: 100%;\n  margin: 0;\n  box-sizing: border-box;\n  transition: margin-left 0.3s ease;\n}\n\n/* Layout adjustments when sidebar is visible */\n.App.with-sidebar {\n  position: relative;\n}\n\n.App.with-sidebar .App-main {\n  margin-left: 280px;\n  width: calc(100% - 280px);\n  max-width: calc(100vw - 280px);\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Content wrapper to center content when sidebar is visible */\n.App.with-sidebar .App-main > * {\n  max-width: 100%;\n  box-sizing: border-box;\n}\n\n/* Ensure containers with max-width are centered and fit within available space */\n.App.with-sidebar .App-main .home-container,\n.App.with-sidebar .App-main .equity-container,\n.App.with-sidebar .App-main .open-positions-container,\n.App.with-sidebar .App-main .trades-container,\n.App.with-sidebar .App-main .pmcc-container,\n.App.with-sidebar .App-main .settings-page,\n.App.with-sidebar .App-main .todo-container {\n  max-width: min(100%, calc(100vw - 280px - 2rem));\n  margin-left: auto;\n  margin-right: auto;\n  box-sizing: border-box;\n}\n\n/* Override specific max-widths when sidebar is visible to ensure they fit */\n.App.with-sidebar .App-main .home-container {\n  max-width: min(1400px, calc(100vw - 280px - 2rem));\n}\n\n.App.with-sidebar .App-main .pmcc-container {\n  max-width: min(1200px, calc(100vw - 280px - 2rem));\n}\n\n/* Prevent horizontal overflow when sidebar is visible */\n.App.with-sidebar {\n  overflow-x: hidden;\n}\n\n.App.with-sidebar .App-main {\n  overflow-x: hidden;\n}\n\n/* Ensure tables and wide content don't overflow */\n.App.with-sidebar .App-main table,\n.App.with-sidebar .App-main .table-container,\n.App.with-sidebar .App-main .data-table {\n  max-width: 100%;\n  overflow-x: auto;\n  box-sizing: border-box;\n}\n\n.App.with-sidebar .App-header {\n  margin-left: 280px;\n  width: calc(100% - 280px);\n  max-width: calc(100vw - 280px);\n  box-sizing: border-box;\n}\n\n.App.with-sidebar .sub-nav {\n  margin-left: 280px;\n  width: calc(100% - 280px);\n  max-width: calc(100vw - 280px);\n  box-sizing: border-box;\n}\n\n@media (max-width: 768px) {\n  .App.with-sidebar .App-main {\n    margin-left: 0;\n    width: 100%;\n    max-width: 100vw;\n  }\n\n  .App.with-sidebar .App-header {\n    margin-left: 0;\n    width: 100%;\n    max-width: 100vw;\n  }\n\n  .App.with-sidebar .sub-nav {\n    margin-left: 0;\n    width: 100%;\n    max-width: 100vw;\n  }\n}\n\n.loading, .error {\n  text-align: center;\n  padding: 2rem;\n  font-size: 1.2rem;\n}\n\n.error {\n  color: #d32f2f;\n  background-color: #ffebee;\n  border-radius: 4px;\n  border: 1px solid #ffcdd2;\n}\n\n.empty-state {\n  text-align: center;\n  padding: 4rem 2rem;\n  color: #666;\n  font-size: 1.1rem;\n}\n\n.data-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 1.5rem;\n  margin-bottom: 2rem;\n}\n\n.data-card {\n  background: white;\n  border-radius: 8px;\n  padding: 1.5rem;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.data-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0,0,0,0.15);\n}\n\n.data-card h3 {\n  color: #282c34;\n  margin-bottom: 0.5rem;\n  font-size: 1.3rem;\n}\n\n.data-card .description {\n  color: #666;\n  margin-bottom: 1rem;\n  line-height: 1.5;\n}\n\n.data-card .source {\n  color: #888;\n  font-size: 0.9rem;\n  margin-bottom: 0.5rem;\n}\n\n.data-card .date {\n  color: #888;\n  font-size: 0.85rem;\n  margin-bottom: 1rem;\n}\n\n.data-preview {\n  padding-top: 1rem;\n  border-top: 1px solid #eee;\n  color: #555;\n}\n\n.refresh-btn {\n  display: block;\n  margin: 2rem auto;\n  padding: 0.75rem 2rem;\n  background-color: #282c34;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.refresh-btn:hover {\n  background-color: #3d4148;\n}\n\n.refresh-btn:active {\n  transform: scale(0.98);\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
